/**
 * @generated SignedSource<<df2ce88826d3a41bb38317b7a814f197>>
 * @relayHash a08f123b6b07a31b8073c836ee129767
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd2c823ad40c4cb156b67202af2c6b9e922cc488b39fcc33bb68f8a483471c2f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type releaseVersionsCacheServicesValidateQuery$variables = {
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  id: string;
};
export type releaseVersionsCacheServicesValidateQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly selectableValueOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly selectableGroupKey: string | null | undefined;
          readonly selectableLabel: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type releaseVersionsCacheServicesValidateQuery = {
  response: releaseVersionsCacheServicesValidateQuery$data;
  variables: releaseVersionsCacheServicesValidateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterById"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "selectableLabel"
},
v7 = {
  "kind": "ScalarField",
  "name": "selectableGroupKey"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "releaseVersionsCacheServicesValidateQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraSelectableValueConnection",
                "kind": "LinkedField",
                "name": "selectableValueOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSelectableValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraHasSelectableValueOptions",
            "abstractKey": "__isJiraHasSelectableValueOptions"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "releaseVersionsCacheServicesValidateQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraSelectableValueConnection",
                "kind": "LinkedField",
                "name": "selectableValueOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSelectableValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraHasSelectableValueOptions",
            "abstractKey": "__isJiraHasSelectableValueOptions"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cd2c823ad40c4cb156b67202af2c6b9e922cc488b39fcc33bb68f8a483471c2f",
    "metadata": {},
    "name": "releaseVersionsCacheServicesValidateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "90a3fc305cc12cf7ee6fa89acc4448c0";

export default node;
